/**
 * Die Meldezeile nach einem Sammelvorgang — mit dem Weg zurück.
 *
 * Einmal geschrieben, von der Stammdaten-Tabelle und von der Liste benutzt:
 * Zwei Kopien der Umkehr liefen früher oder später auseinander, und eine
 * halbe Rücknahme wäre schlimmer als keine.
 *
 * Gerechnet und getextet wird in `src/ruecknahme.js`; hier steht nur, was
 * `document` braucht.
 *
 * Das Angebot ist flüchtig. Es steht bis zum nächsten Sammelvorgang oder bis
 * die Ansicht verlassen wird; nichts davon überlebt ein Neuladen. Ein Verlauf
 * wäre die nächste Ausbaustufe, nicht diese.
 */

import { ergebnisText, nimmZurueck, ruecknahmeText } from '../ruecknahme.js';

export function zeigeErgebnis(meldung, db, ergebnis, optionen = {}) {
  meldung.replaceChildren(document.createTextNode(ergebnisText(ergebnis)));
  if (!ergebnis.ruecknahme) return;

  const knopf = document.createElement('button');
  knopf.type = 'button';
  knopf.className = 'knopf zuruecknehmen';
  knopf.textContent = 'Zurücknehmen';

  // Der Knopf hängt in `meldung`. Wer die Meldung mit `replaceChildren` neu
  // setzt, nimmt ihn also mit heraus — deshalb wird er bei jedem Neusetzen
  // wieder mit angehängt, sonst zeigte `knopf.disabled = false` danach auf
  // einen abgehängten Knoten.
  const setze = (text, mitKnopf) => {
    if (mitKnopf) meldung.replaceChildren(document.createTextNode(text), ' ', knopf);
    else meldung.replaceChildren(document.createTextNode(text));
  };

  knopf.addEventListener('click', async () => {
    knopf.disabled = true;
    let text;
    let nochmal = false;
    try {
      text = ruecknahmeText(await nimmZurueck(db, ergebnis.ruecknahme,
        { geraet: optionen.geraet }));
    } catch (fehler) {
      text = fehler.message;
      // Wieder freigeben statt gesperrt zu lassen: Bereits zurückgenommene
      // Sätze tragen einen frischen Zeitstempel, an dem der `erwartet`-Riegel
      // sie beim nächsten Versuch erkennt und überspringt — ein erneuter Klick
      // trifft also nur noch, was beim ersten Mal nicht durchkam.
      nochmal = true;
      knopf.disabled = false;
    }

    // Aufgefrischt wird auf beiden Wegen: Bricht das Schreiben zwischen zwei
    // Registern ab, steht das erste bereits zurückgenommen in der Datenbank —
    // eine Ansicht, die weiter den alten Stand zeigt, wäre schlimmer als die
    // Fehlermeldung. Und ein Fehler beim Auffrischen darf umgekehrt nicht wie
    // eine gescheiterte Rücknahme aussehen.
    try {
      await optionen.aufFrischen?.();
    } catch (fehler) {
      text += ` (Ansicht nicht aufgefrischt: ${fehler.message})`;
    }
    setze(text, nochmal);
  });

  meldung.append(' ', knopf);
}
